import { Link } from "react-router-dom";
import { products } from "@/mocks/products";

export default function FeaturedProducts() {
  const featuredProducts = products.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              热门牛奶片推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              基于真实用户测评和销量数据，精选最受欢迎的牛奶片产品
            </p>
          </div>
          <Link
            to="/category/children"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap no-underline hover:no-underline"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featuredProducts.map((product) => (
            <Link
              key={product.id}
              to={`/article/${product.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-background-300 transition-all duration-300 no-underline hover:no-underline"
            >
              <div className="relative aspect-square overflow-hidden bg-background-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {product.tags.length > 0 && (
                  <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                    {product.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 text-[11px] font-medium rounded-md bg-accent-500 text-background-50"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-1">{product.brand}</p>
                <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {product.name}
                </h3>
                <div className="flex items-center gap-1.5 mb-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`text-[10px] ${
                          i < Math.floor(product.rating)
                            ? "ri-star-fill text-accent-500"
                            : "ri-star-line text-foreground-300"
                        }`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-600">{product.rating}</span>
                  <span className="text-xs text-foreground-400">({product.reviewCount}评)</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-primary-500">
                    ¥{product.price}
                  </span>
                  <span className="text-[11px] text-foreground-500 bg-background-100 px-2 py-0.5 rounded-md">
                    {product.calciumContent}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}